/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

interface IObjetivoDisplayBase {
	[key: string]: string | boolean;
}

const initialState: IObjetivoDisplayBase = {
	displayAll: localStorage.getItem('objetivoDisplayState') !== 'false'
};

const objetivoDisplayStateSlice = createSlice({
	name: 'objetivoDisplayState',
	initialState,
	reducers: {
		displayAllObjetivosPlanificacionSesion: () => {
			localStorage.removeItem('objetivoDisplayState');
			const displayAll = localStorage.getItem('objetivoDisplayState') !== 'false';
			return { displayAll };
		},
		hideAllObjetivosPlanificacionSesion: (state) => {
			localStorage.setItem('objetivoDisplayState', 'false');
			state.displayAll = false;
		},
		displaySpecificObjetivoPlanificacionSesion: (state, action) => {
			state[action.payload] = true;
		},
		hideSpecificObjetivoPlanificacionSesion: (state, action) => {
			state[action.payload] = false;
		}
	}
});

export const {
	displayAllObjetivosPlanificacionSesion,
	hideAllObjetivosPlanificacionSesion,
	displaySpecificObjetivoPlanificacionSesion,
	hideSpecificObjetivoPlanificacionSesion
} = objetivoDisplayStateSlice.actions;

export default objetivoDisplayStateSlice.reducer;
